import { Website } from "@/config";
import type { LanguageCode } from "@/services/translation";

const setLinkAlternate = (alternateLinks: { lang: LanguageCode; url: string }[]) => {
  const existingLinks = document.querySelectorAll('head link[rel="alternate"]');
  existingLinks.forEach((link) => link.remove());

  alternateLinks.forEach((link) => {
    const linkElement = document.createElement("link");
    linkElement.setAttribute("rel", "alternate");
    linkElement.setAttribute("hreflang", link.lang);
    linkElement.setAttribute("href", link.url);
    document.head.appendChild(linkElement);
  });
};

export const createPageTitle = (title: string, addSuffix = true): string => {
  if (addSuffix) {
    return title + " | " + Website.name;
  } else {
    return title;
  }
};

export const MetaTags = {
  setLinkAlternate,
};
